module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Histori Potongan\n        ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "Dept. Item"
    },
    model: {
      value: (_vm.searchSelectDepartement),
      callback: function($$v) {
        _vm.searchSelectDepartement = $$v
      },
      expression: "searchSelectDepartement"
    }
  }, _vm._l((_vm.departements), function(dept) {
    return _c('Option', {
      key: dept,
      attrs: {
        "value": dept.id
      }
    }, [_vm._v("\n                        " + _vm._s(dept.deptName) + "\n                    ")])
  }), 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "daterange",
      "split-panels": "",
      "placeholder": "Select date"
    },
    model: {
      value: (_vm.dateFromTo),
      callback: function($$v) {
        _vm.dateFromTo = $$v
      },
      expression: "dateFromTo"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('i-switch', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.markingIdSelected != '' || _vm.dateFromTo[0] != null),
      expression: "markingIdSelected != '' || dateFromTo[0] != null"
    }],
    attrs: {
      "size": "large"
    },
    model: {
      value: (_vm.isOnlyBca),
      callback: function($$v) {
        _vm.isOnlyBca = $$v
      },
      expression: "isOnlyBca"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("BCA")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("All")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSearchButton()),
      expression: " showSearchButton() "
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.loadingSearch,
      "icon": "ios-search"
    },
    on: {
      "click": _vm.getPayment
    }
  }, [(!_vm.loadingSearch) ? _c('span', [_vm._v("Cari")]) : _c('span', [_vm._v("Wait.....")])])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.payments.length > 0) ? [_c('Tag', {
    attrs: {
      "color": "green"
    }
  }, [_vm._v("Total : Rp " + _vm._s(_vm._f("numberFormatted")(_vm.total)))]), _vm._v(" "), (_vm.totalPayment > 0) ? _c('Tag', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("Pembayaran : Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalPayment)))]) : _vm._e(), _vm._v(" "), (_vm.totalDiscount > 0) ? _c('vue-csv-downloader', {
    attrs: {
      "data": _vm.paymentsDiscCsv,
      "fields": _vm.fieldCsv,
      "download-name": _vm.csvName
    }
  }, [_vm._v("\n                 \n                "), _c('Tag', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Potongan : Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalDiscount)))])], 1) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('Table', {
    ref: "table",
    attrs: {
      "columns": _vm.tableColumns,
      "data": _vm.payments,
      "no-data-text": ""
    }
  })] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17124d07","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentDiscountList.vue
// module id = 1781
// module chunks = 1